import './polyfills';
import './sentry';
import { createRoot } from 'react-dom/client';
import React from 'react';
import './i18n';
import App from './js/shared/components/app';
import 'react-loading-skeleton/dist/skeleton.css';
import './css/style.scss';
// gild-loader.scss intentionally imported after `style.scss` due to its use
// of `@use` within scss. we want gild styles to be output after base styles,
// but scss requires any use of `@use` to come before any `@import` within
// any given single scss file.
import './css/gild-loader.scss';

const container = document.getElementById('app');
const root = createRoot(container);
root.render(<App />);
